<template>
  <div v-if="redirection">
    <img
      alt="PayJoy Logo"
      class="d-sm-none pj-mobile-logo"
      :src="`${useAsset('img/logo_bg_white.svg')}`"
    />
    <img
      alt="PayJoy Logo"
      class="d-none d-sm-block pj-desktop-logo"
      :src="`${useAsset('img/logo_bg_white.svg')}`"
    />
  </div>
  <router-link v-else :to="{ name: routeName }">
    <img
      alt="PayJoy Logo"
      class="d-sm-none pj-mobile-logo"
      :src="`${useAsset('img/logo_bg_white.svg')}`"
    />
    <img
      alt="PayJoy Logo"
      class="d-none d-sm-block pj-desktop-logo"
      :src="`${useAsset('img/logo_bg_white.svg')}`"
    />
  </router-link>
</template>

<script setup lang="ts">
import useAsset from "@/apps/person-registration/shared-helpers/useAsset";

defineProps({
  routeName: {
    default: "Home",
    type: String,
  },
  redirection: {
    default: false,
    type: Boolean,
  },
});
</script>
